// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"86":"683bd828","800":"71225e46","848":"71225e46","875":"cb20271c"}[chunkId] + ".chunk.css";
};